import { render, staticRenderFns } from "./teacherPicker.vue?vue&type=template&id=70861695&scoped=true"
import script from "./teacherPicker.vue?vue&type=script&lang=ts"
export * from "./teacherPicker.vue?vue&type=script&lang=ts"
import style0 from "./teacherPicker.css?vue&type=style&index=0&id=70861695&prod&scoped=true&lang=css&external"
import style1 from "@/components/common/modern/modern.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/components/acquisitionList/ui/acquisitionViews.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70861695",
  null
  
)

export default component.exports